import vue from 'vue'
import Router from 'vue-router'
// import store from './store'

vue.use(Router)
let router = new Router({
	mode: 'history',
	routes: [
        
		{
			path: '/',
			name: 'home',
			component: () => import('./components/Common/appHome'),
			meta:{
				notFound:false,
			}
		
		},
		{
			path: '/services',
			name: 'services',
			component: () => import('./components/Services/servicesMain'),
			notFound:false,
		},
		{
			path: '/aboutUs',
			name: 'aboutUs',
			component: () => import('./components/About/aboutUsMain'),
			notFound:false,
		},
		{
			path: '/visionMission',
			name: 'visionMission',
			component: () => import('./components/About/visionMission'),
			notFound:false,
			props:true,
		},
		{
			path: '/projects',
			name: 'projects',
			component: () => import('./components/Projects/projectPage'),
			notFound:false,
		},
		{
			path: '/contactUs',
			name: 'contactUs',
			component: () => import('./components/ContactUs/contactUs'),
			notFound:false,
		},


		{
			path: '*',
			name: '404',
			component: () => import('./components/Common/404'),
			notFound:true,
		},






	],
    scrollBehavior() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0;
	},

})



export default router